import GooogleTagManagerNg from '../GoogleTagManagerNg';

interface WithGoogleAnalyticsProps {
  children: JSX.Element;
}

export default function WithGoogleAnalytics({ children }: WithGoogleAnalyticsProps): JSX.Element {
  if (!GooogleTagManagerNg.isInitialized()) {
    GooogleTagManagerNg.initialize();
  }

  return children;
}
